export enum FeatureFlags {
  BASE_IMAGE_UPDATE = 'base-image-update',
  DR_MODE_SELECTION = 'dr-mode-selection',
  SFTP_ARTIFACTORY_DESTINATION = 'sftp-artifactory-destination',
  AZURE_COB = 'azure-cob',
  ENV_SANITY_TEST_AWS = 'env-sanity-test-aws',
  AZURE_SCHEDULE_STATE = 'env-schedule-state-azure',
  AZURE_RUNBOOK = 'azure-runbook',
  AZURE_TERMINATE = 'env-terminate-aws'
}
